import { AnyAction } from 'redux';
import { EinreichenResponseModel } from '@ps20/bff-models';
import { DoRequestResponse } from '@ps20-frontend/shop-integration-redux';
import { CheckoutActions } from '../checkout.actions';

export const antragsResponseReducer = function (
  sectionState: DoRequestResponse<EinreichenResponseModel> | string | null = null,
  action: AnyAction,
): DoRequestResponse<EinreichenResponseModel> | string | null {
  switch (action.type) {
    case CheckoutActions.ANTRAG_EINREICHEN: {
      return action.payload;
    }
    case CheckoutActions.ANTRAG_RESPONSE_RECEIVED: {
      return JSON.stringify(action.payload);
    }
    default:
      return sectionState;
  }
};
